<template>
	<div>
		<span class="text-primary">
			<i
				class="fa fa-hourglass-half fa-lg icon-button"
				title="Exibir Timeline"
				@click.stop="mostrarTimeline()"
			></i>
		</span>

        <b-modal
            hide-footer
            size="xl"
            v-model="mostrarModal"
            @show="obterTimeLine()"
            >
            <template #modal-title>
                <div class="d-flex justify-content-between align-items-center w-100">
                <span class="modal-title-text">TIMELINE</span>
                <div class="buttons">
                    <b-button
                        variant="primary"
                        :class="{ active: tipoTimeLine === 'Resumida' }"
                        @click="obterTimeLine(tipoTimeLine = 'Resumida')"
                        >
                        TimeLine Mensal Resumida
                    </b-button>
                    <b-button
                        variant="primary"
                        class="ml-2"
                        :class="{ active: tipoTimeLine === 'Detalhada' }"
                        @click="obterTimeLine(tipoTimeLine = 'Detalhada')"
                        >
                        TimeLine Mensal Detalhada
                    </b-button>
                </div>
                </div>
            </template>

            <time-line
                :itens="itensTimeLine"
                :isModal="true"
            ></time-line>
        </b-modal>
	</div>
</template>

<script>
import TimeLine from './TimeLineOperacionalizacoes'
import ConveniosServicos from '../../../ConvenioServicos'

export default {
  props: {
        convenio: {
            type: Object,
            default: () => ({})
        },
        idPrestacaoMensal: {
            type: Number,
            default: 0
        },
        tipoTimeLine: {
            type: String,
            default: 'Resumida'
        }

    },

  data() {
    return {
        mostrarModal: false,
        itensTimeLine: null,
    }
  },

  methods: {
    mostrarTimeline() {
			this.mostrarModal = true
		},

    obterTimeLine(tipoTimeLine) {
      ConveniosServicos
        .obterTimeLine(
            this.convenio.idConvenio,
            this.idPrestacaoMensal,
            tipoTimeLine
        ).then(
        response => {
            if (response){
            if (response.success) {
                this.itensTimeLine = response.data
            } else {
                this.$toast.error(
                "Erro ao obter timeline",
                "ERROR",
                this.$toastConfig.error
                );
            }
            }
        })
      }
  },

  components: {
    TimeLine
  },

}
</script>
<style scoped>
.b-modal .modal-content {
    max-width: 90vw;
    max-height: 250vh;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 20px;
    border-radius: 5px;
}

.modal-title-text {
  font-weight: bold;
}

.buttons {
    display: flex;
    justify-content: right;
    margin-left: 640px;
}

.b-button.active {
  background-color: blue;
  color: white;
}

.b-button {
  background-color: lightgray;
  color: black;
  transition: all 0.3s ease;
}

</style>






